const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const mediaUrl = (src) => {
  if (!src) return src;
  if (src.startsWith("/api/")) return `${BACKEND}${src}`;
  return src;
};

export const catVisible = (cat, all) => {
  if ((cat.product_count || 0) > 0) return true;
  return all.some((c) => c.parent_id === cat.id && (c.product_count || 0) > 0);
};

export const eur = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(n || 0);

export const STATUS_LABELS = {
  pendiente: "Pendiente",
  pedido_recibido: "Pedido recibido",
  transferencia_pendiente: "Transferencia pendiente",
  pago_recibido: "Pago recibido",
  en_preparacion: "En preparación",
  en_fabricacion: "En fabricación",
  preparado: "Preparado",
  enviado: "Enviado",
  entregado: "Entregado",
  cancelado: "Cancelado",
  incidencia: "Incidencia",
};

export const STATUS_COLORS = {
  pendiente: "bg-amber-100 text-amber-800",
  pedido_recibido: "bg-blue-100 text-blue-800",
  transferencia_pendiente: "bg-orange-100 text-orange-800",
  pago_recibido: "bg-emerald-100 text-emerald-800",
  en_preparacion: "bg-indigo-100 text-indigo-800",
  en_fabricacion: "bg-purple-100 text-purple-800",
  preparado: "bg-cyan-100 text-cyan-800",
  enviado: "bg-teal-100 text-teal-800",
  entregado: "bg-green-100 text-green-800",
  cancelado: "bg-red-100 text-red-800",
  incidencia: "bg-rose-100 text-rose-800",
};
